<!-- Показывает пункт настроек телеметрии в списке настроек компании -->
<template>
  <SettingSection
    title="Телеметрия"
    icon-variant="telemetry"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";

export default {
  name: "TelemetrySettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 1 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      `,
      links: [
        {
          label: "Трекеры и датчики",
          route: { name: "Integrations", query: { tab: "trackers" } },
        },
        {
          label: "Часовой пояс телеметрии",
          route: { name: "TelemetrySettings" },
        },
      ],
    };
  },
};
</script>
